import { MonitoringTabs } from '../models/monitoring.model';

import routes from './routes';

// Routes have changed for formulasCatalog, formulasApproved, formulaEditor and datasetsCatalog.
// Configure has been replaced with System settings

const redirects = [
    {
        to: routes.formulasMain,
        from: '/formulas/catalog',
    },
    {
        to: routes.datasetCatalog,
        from: '/datasets/links/catalog',
    },
    {
        to: '/messages/Draft/:formulaId',
        from: '/formulas/editor/:formulaId',
    },
    {
        to: '/messages/Live/:formulaId',
        from: '/formulas/:formulaId',
    },
    {
        to: '/messages/Live/:formulaId',
        from: '/messages/Active/:formulaId',
    },
    {
        to: '/messages/Draft/:formulaId',
        from: '/messages/Inactive/:formulaId',
    },
    {
        to: routes.optimizedMonitoringTab(MonitoringTabs.Messaging),
        from: '/monitoring/messaging',
    },
    {
        to: routes.liveMessages,
        from: '/monitoring/live-messages',
    },
    {
        to: routes.optimizedMonitoringTab(MonitoringTabs.Events),
        from: '/monitoring/events',
    },
    {
        to: routes.optimizedMonitoringTab(MonitoringTabs.Performance),
        from: '/monitoring/performance',
    },
    {
        to: routes.monitoringMain,
        from: '/monitoring/reports',
    },
    {
        to: routes.formulasMain,
        from: '/campaigns',
    },
    {
        to: routes.genAI,
        from: '/snippets',
    },
    {
        to: routes.eventsMain,
        from: '/system-setup/events',
    },
    {
        to: routes.eventsMain,
        from: '/configure/events',
    },
    {
        to: routes.funnelMain,
        from: '/configure/funnel',
    },
    {
        to: routes.frequencyLimits,
        from: '/configure/default-frequency-limits',
    },
    {
        to: routes.accountMain,
        from: '/configure/account',
    },
    {
        to: routes.payment,
        from: '/configure/account/payments',
    },
    {
        to: routes.team,
        from: '/configure/account/team',
    },
    {
        to: routes.integrationMain,
        from: '/configure/integrations',
    },
    {
        to: routes.integrationEvents,
        from: '/configure/integrations/events',
    },
    {
        from: '/configure/integrations/events/create/:eventProviderName',
        to: '/system-setup/integrations/events/create/:eventProviderName',
    },
    {
        to: routes.integrationMessage,
        from: '/configure/integrations/message',
    },
    {
        from: '/configure/integrations/create/:providerName',
        to: '/system-setup/integrations/create/:providerName',
    },
    {
        from: '/configure/integrations/detail/:id',
        to: '/system-setup/integrations/detail/:id',
    },
    {
        to: routes.systemSetupMain,
        from: '/configure',
    },

    {
        to: routes.audienceCreate,
        from: '/audiences/create',
    },
    {
        from: '/audiences/details/:audience_id',
        to: '/message-settings/audiences/details/:audience_id',
    },
    {
        to: routes.audience,
        from: '/audiences',
    },
    {
        from: '/configure/triggers/:id',
        to: '/message-settings/triggers/:id',
    },
    {
        to: routes.compoundTriggerCreate,
        from: '/configure/triggers/create',
    },
    {
        to: routes.compoundTriggers,
        from: '/configure/triggers',
    },
    {
        to: routes.customComponentCreation,
        from: '/monitoring/label-management/create-custom-component',
    },
    {
        to: routes.viewCustomComponent(':componentId'),
        from: '/monitoring/label-management/custom-component/:componentId',
    },
    {
        to: routes.labelManagement,
        from: '/monitoring/label-management',
    },
    {
        to: routes.labelDetail(':id'),
        from: '/monitoring/label-management/:id/details',
    },
    {
        to: routes.topicManagement,
        from: '/monitoring/topic-management',
    },
    {
        to: routes.topicManagementCreation,
        from: '/monitoring/topic-management/create',
    },
    {
        to: routes.topicManagementDetail(':id'),
        from: '/monitoring/topic-management/:id/details',
    },
    //   DataSets
    {
        to: routes.datasetsList,
        from: '/datasets/catalog',
    },
    {
        to: routes.datasetRelationCreate,
        from: '/datasets/links/create',
    },
    {
        to: routes.datasetsCreate,
        from: '/datasets/create',
    },
    {
        to: routes.datasetCatalog,
        from: '/datasets/',
    },
    {
        to: routes.datasetsView(':datasetId?:filters'),
        from: '/datasets/:datasetId?:filters',
    },
    {
        to: '/message-settings/datasets/:datasetId',
        from: '/datasets/:datasetId?',
    },
    {
        to: routes.labelManagement,
        from: '/personalization',
    },
    {
        to: '/monitoring/message-performance/message/:formulaId/label/:labelId/variant',
        from: '/live-messages/message/:formulaId/label/:labelId',
    },
    {
        to: '/monitoring/message-performance/message/:formulaId/label',
        from: '/live-messages/message/:formulaId',
    },
    {
        from: '/system-setup/funnel-events',
        to: routes.eventsMain,
    },
];
export default redirects;
